import { Component, Input } from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';
import * as Highcharts from 'highcharts';
import HighchartsSankey from 'highcharts/modules/sankey';
import { Pie_Chart_Data } from './chart.constants';
HighchartsSankey(Highcharts);

// Set global Highcharts options to disable thousand separators
Highcharts.setOptions({
  lang: {
    thousandsSep: ''
  },
  tooltip: {
    pointFormat: '{point.name}: {point.y}'
  }
});

@Component({
  selector: 'chart',
  standalone: true,
  imports: [HighchartsChartModule],
  templateUrl: './chart.component.html',
  styleUrl: './chart.component.scss',
})
export class ChartComponent {
  @Input() pieChartData!: Array<any>;

  Highcharts: typeof Highcharts = Highcharts;
  chartData: Highcharts.Options = { ...Pie_Chart_Data };

  ngOnInit() {
    this.chartData.series = [
      {
        type: 'pie',
        data: [...this.pieChartData],
      },
    ];
  }

  getChartStyle(chartVisible: boolean): string {
    if (!chartVisible) {
      return 'display: none;';
    }
    const smallHeight = 'height: 260px !important;';
    const display = 'display: flex;';

    let width = 'width: 180px;';
    let height = 'height: 130px !important;';

    return `${display}  border-radius: 12px;`;
  }
}
